if (document.getElementById("partner-form-choice")) {
    // Get the required elements
    const new_partner_form = document.getElementById("new-partner-form");
    const new_referral_form = document.getElementById("new-referral-form");
    const partner_button = document.getElementById("partner-button");
    const project_button = document.getElementById("project-button");

    // Show the correct form, and give feedback on the button
    function showForm(e) {
        if (e.target.id == "partner-button") {
            button = partner_button;
            otherButton = project_button;
            form = new_partner_form;
            otherForm = new_referral_form;
        } else if (e.target.id == "project-button") {
            button = project_button;
            otherButton = partner_button;
            form = new_referral_form;
            otherForm = new_partner_form;
        }

        // Show which button was last clicked
        button.classList.add("cta-secondary-active");
        otherButton.classList.remove("cta-secondary-active");

        // Show the correct form
        form.classList.remove("hidden");
        otherForm.classList.add("hidden");
    }

    // Add event listeners to buttons
    partner_button.addEventListener("click", showForm);
    project_button.addEventListener("click", showForm);
}
